__turbopack_context__.v({
  "className": "ibm_plex_sans_124ae40e-module___xIgaa__className",
});
